export const API_BASE_URL = "https://cms.launchlabs.app/api";
export const JWT_TOKEN =
  "26c224d354d62d8158a787cc61cfdc4b6935130e4bd5c64d6e698b208c83912afa8aa52a580aebf6a48db269e526196ea177c532e8a5e3f78a1c5e203db54831f9a9d12ba80eb12e84bcae2088eba569b2801c3997d8c39ada8dae746ee2f103e2902f3c15dec75316fc1eac4143d40b28af7a0cdebf5b12818c73d5ccd7f5d0";
